<template>
  <div>
    <div class="menu-box">
      <menu-title></menu-title>
    </div>
    <h2>
      {{ ccass_name }} {{ startDate | formatDate }} -
      {{ endDate | formatDate }}持股变动 总价值：{{
        sum_value | money
      }}
      总价值变化：{{ sum_value_change | money }}
    </h2>
    <Form inline>
      <FormItem prop="startDate">
        <DatePicker
          type="date"
          show-week-numbers
          format="yyyy-MM-dd"
          v-model="startDate"
          placeholder="Select date"
        ></DatePicker>
      </FormItem>
      <FormItem prop="endDate">
        <DatePicker
          type="date"
          show-week-numbers
          v-model="endDate"
          format="yyyy-MM-dd"
          placeholder="Select date"
        ></DatePicker>
      </FormItem>
      <FormItem>
        <Button
          type="primary"
          @click="fetchData(participantId, startDate, endDate)"
          >go</Button
        >
      </FormItem>
    </Form>

    <h2></h2>

    <my-table :columns="headers" :data="list" :loading="loading">
      <template slot-scope="item">
        <td>{{ item.index + 1 }}</td>
        <td>
          <router-link :to="'/xccass/' + item.data.stockCode">{{
            item.data.stockCode
          }}</router-link>
        </td>
        <td>{{ item.data.name }}</td>
        <td class="t-right">{{ item.data.holding | money }}</td>
        <td>{{ item.data.price }}</td>
        <td class="t-right">{{ item.data.value | money }}</td>
        <td class="t-right">{{ item.data.holdingChange | money }}</td>
        <td class="t-right">{{ item.data.valueChange | money }}</td>
        <td class="t-right">{{ item.data.stake }}</td>
        <td class="t-right">
          {{ item.data.stakeChange | formatFloatByorder }}
        </td>
        <td class="t-right">{{ item.data.time | formatDay }}</td>
      </template>
    </my-table>
    <div
      class="nodata"
      style="text-align:center;pading:10px"
      v-if="list.length < 1 && !loading"
    >
      暂无数据，可按照日期查询历史数据
    </div>
  </div>
</template>
<script>
import menuTitle from "../components/ccass-menu-title";

import dayjs from "dayjs";
export default {
  components: {
    menuTitle
  },
  data() {
    return {
      ccass_name: "",
      participantId: "",
      startDate: "",
      endDate: "",
      headers: [
        {
          title: "序列",
          key: "id",
          align: "left"
        },
        {
          title: "代码",
          key: "stockCode"
        },
        {
          title: "股票名称",
          key: "name"
        },

        {
          title: "持股数",
          key: "holding",
          align: "right"
        },
        {
          title: "股价",
          key: "price"
        },
        {
          title: "价值",
          key: "value",
          align: "right"
        },
        {
          title: "近一日持股变化",
          key: "holdingChange",
          align: "right",
          sortType: "desc"
        },
        {
          title: "近一日价值变化",
          key: "valueChange",
          align: "right"
        },
        {
          title: "持仓占比%",
          key: "stake",
          align: "right"
        },
        {
          title: "持股占比一日变化%",
          key: "stakeChange",
          align: "right"
        },
        {
          title: "日期",
          key: "time",
          align: "right"
        }
      ],
      list: [],
      loading: false
    };
  },

  methods: {
    async fetchData(participantId, startTime, endTime) {
      startTime = dayjs(startTime).unix();
      endTime = dayjs(endTime).unix();
      const queryStartTime = dayjs.unix(startTime).format("YYYY-MM-DD");
      const queryEndTime = dayjs.unix(endTime).format("YYYY-MM-DD");
      const { data } = await this.$api.GetCassBrokersHoldingChange({
        participantId,
        startTime,
        endTime
      });
      if (!data) {
        return;
      }
      this.ccass_name = data.participantNameCN;
      this.list = data.data || [];
      this.$router.replace({
        name: "cchange",
        params: {
          ccass_id: participantId,
          startTime: queryStartTime,
          endTime: queryEndTime
        }
      });
    }
  },
  mounted() {
    this.startDate =
      this.$route.query.startTime ||
      dayjs()
        .subtract(2, "day")
        .toDate();
    this.endDate =
      this.$route.query.endTime ||
      dayjs()
        .subtract(1, "day")
        .toDate();
    this.participantId = this.$route.params.ccass_id;
    this.fetchData(this.participantId, this.startDate, this.endDate);
  },
  computed: {
    sum_value() {
      let value = 0;
      this.list.forEach(item => {
        value = item.value + value;
      });
      return value;
    },
    sum_value_change() {
      let value = 0;
      this.list.forEach(item => {
        value = item.valueChange + value;
      });
      return value;
    }
  },
  filters: {
    formatFloatByorder(val) {
      return parseFloat(val / 100).toFixed(2);
    }
  },
  watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
  margin: 20px auto;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.big-table {
  position: absolute;
  width: 1460px;
  left: 50%;
  margin-left: -730px;
}

/* .ivu-table-row.no-border{
      border: 0px;
  }
  .ivu-table-row.no-border td{
      border: 0px!important;
      background: #000;
  } */
.menu-box {
  position: absolute;
  top: 90px;
  left: 400px;
  z-index: 4000;
}
</style>
